export default "__VITE_ASSET__DdFwrUrG__"